/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import {
  propTypesIllustration,
  propTypesTextHtml,
} from '../../../constants/Proptypes';

const propTypesItemsSimpleGridWithIllustration = {
  simple_column_title: PropTypes.string,
  simple_subtitle: PropTypes.string,
  simple_column_illustration: PropTypes.shape(propTypesIllustration),
  simple_column_content: PropTypes.shape(propTypesTextHtml),
  simple_column_last_content: PropTypes.shape(propTypesTextHtml),
};

export const propTypesDataSimpleGridWithIllustration = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape(propTypesItemsSimpleGridWithIllustration)
  ),
};
